import { getCookie } from './getCookie';
import { getWindow } from './getWindow';

export const getIsAuthenticated = () => (getWindow() ? Boolean(getCookie('yandex_login')) : false);
